import Head from 'next/head';
import Script from 'next/script';
import { useRouter } from 'next/router';
import { useEffect, ReactNode } from 'react';

import FavIcons from 'components/layout/FavIcons';
import MainContent from 'components/layout/MainContent';
import { defaultMeta } from 'components/layout/PageMeta';

import { buildSdkUrl } from 'utils/helpers';

import css from './Layout.module.scss';

interface IProps {
  children: ReactNode;
}

export default function Layout({ children }: IProps) {
  const router = useRouter();

  const changeRoute = async (url: string) => {
    // вручную осуществляем навигацию, чтобы сохранить поведение гибридного приложения,
    // а не полностью заново все отрисовывать после перехода
    await router.push(url);
  };

  useEffect(() => {
    // если по каким-то причинам попадем сюда второй раз,
    // то повторной инициализации не будет
    if (ZnanieSDK && !document.querySelector('#znanie-header')) {
      ZnanieSDK.init({
        headerProps: {
          hideQuestionLink: true,
        },
        // включаем скрытую опцию, которая превращает все навигационные ссылки в относительные
        _usage: 'internal',
      });

      // подписываемся на нажатие любой навигационной ссылки (в рамках нашего сайта) из хедера/футера
      ZnanieSDK.on('linkClick', changeRoute);
    }

    return () => {
      ZnanieSDK.off('linkClick', changeRoute);
    };
  }, []);

  return (
    <>
      <Head>
        <title>{defaultMeta.title}</title>
        <FavIcons />

        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no"
        />

        <meta
          name="description"
          content={defaultMeta.description}
          key="description"
        />
        <meta name="og:title" content={defaultMeta.title} key="og_title" />
        <meta
          name="og:description"
          content={defaultMeta.description}
          key="og_description"
        />
        <meta name="og:image" content={defaultMeta.image} key="og_image" />

        <meta
          name="facebook-domain-verification"
          content="i0v6q7vlxspo58iuah2ft5c8nl6uwg"
        />
        <meta name="yandex-verification" content="adddda9d001da534" />
        <meta
          name="google-site-verification"
          content="GLJUEVM4wYnWdrTJ-F9GS2ljGcBTdLnCqqbHipWxAlc"
        />

        <link rel="stylesheet" href={buildSdkUrl('css')} type="text/css" />
      </Head>
      <div className={css.root}>
        <MainContent>{children}</MainContent>
      </div>
      <Script src={buildSdkUrl('js')} strategy="beforeInteractive" />
    </>
  );
}
